import { openMobileFilters, initOffsetSticky } from "./mobileFilters";
import { loadSubmenu } from "./menuLoader";

export function InitSuperMenu(container = '*[data-action]') {
    // If an item has the data-attribute data-action
    let objDataAction = $(container);
    if (objDataAction) {
        objDataAction.each(function () {
            $(this).on('click', function (event) {
                var objButton = $(this);
                var strDataClick = $(this).attr('data-action');

                //-- If action => toggle
                if (strDataClick) {
                    switch (strDataClick) {
                        case 'toggle-next':
                            toggleMenu(objButton);
                            break;
                        case 'toggle-submenu':
                            toggleSubMenu(objButton, event);
                            break;
                        case 'toggle-submenu-main':
                            objButton.parent().parent().toggleClass('active');
                            break;
                        case 'toggle-slide-left':
                            toggleSlideLeft(objButton);
                            break;
                        case 'toggle-accordion':
                            toggleAccordion(objButton, event);
                            break;
                    }
                }
            });
        });
    }
}

function clickNextToContainer(objContainer, objClose) {
    $(document).on('click', function (e) {
        if (!$(e.target).closest(objContainer).length) {
            objClose.removeClass('active');
        }
    });
}

const toggleMenu = (objButton) => {
    objButton.toggleClass('active');
    objButton.next().toggleClass('active');
    const objContainer = $(objButton.parent(), objButton);
    clickNextToContainer(objContainer, objButton);
};

const toggleSubMenu = (objButton, event) => {
    // Desktop nav-modus: laat href navigeren (geen toggle)
    const unifiedMenu = document.querySelector('.unified-menu');
    if (window.innerWidth >= 1024 && unifiedMenu && !unifiedMenu.classList.contains('active')) {
        return true;
    }
    if (event) event.preventDefault();

    // Lazy-load submenu content if needed, then toggle
    const $menuItem = objButton.closest('li.menu-hover, .um-footer-mobile .text-sm');
    loadSubmenu($menuItem).then(() => {
        // Submenu in the supermenu
        // Change the color of the clicked link
        $('a[data-action="toggle-submenu"].text-primary-mint').addClass('text-neutral').removeClass('text-primary-mint');
        // Remove all active submenu's if not the clicked one
        if (objButton.next(':not(.active)')) {
            $('.supermenu-sub.active').removeClass('active');
            objButton.removeClass('text-neutral').addClass('text-primary-mint');
        } else {
            objButton.removeClass('text-primary-mint').addClass('text-neutral');
        }
        objButton.next().toggleClass('active');
    });
};

const toggleAccordion = (objButton, event) => {
    // Desktop nav-modus: geen accordion toggle
    const unifiedMenu = document.querySelector('.unified-menu');
    if (window.innerWidth >= 1024 && unifiedMenu && !unifiedMenu.classList.contains('active')) {
        return true;
    }
    if (event) event.preventDefault();

    const objAccordion = objButton.closest('.supermenu-accordion');
    const objContent = objAccordion.find('.supermenu-accordion-content');

    // Close other open accordions
    $('.supermenu-accordion.active').not(objAccordion).each(function () {
        $(this).removeClass('active');
        $(this).find('.supermenu-accordion-content').css('max-height', '0');
    });

    // Toggle clicked accordion
    if (objAccordion.hasClass('active')) {
        objAccordion.removeClass('active');
        objContent.css('max-height', '0');
    } else {
        objAccordion.addClass('active');
        objContent.css('max-height', objContent[0].scrollHeight + 'px');
        setTimeout(() => {
            objAccordion[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 350);
    }
};

export function toggleSlideLeft(objButton) {
    // Get the target
    var strTarget = objButton.attr('data-target');
    // Supermenu
    var objSlide = $('[data-target-parent="' + strTarget + '"]');
    if (!objSlide.hasClass('active')) {
        if (strTarget === "filters") {
            openMobileFilters();
            //-- Add offset on mobile filter-section -> content is visible instead of under the fixed filter-btn
            initOffsetSticky(objSlide.find('.filters')[0]);
        }
        setTimeout(function () {
            objSlide.addClass('overflow-y-scroll');
        }, 150); //150ms = transition-all time
    } else {
        objSlide.removeClass('overflow-y-scroll');
    }
    // Toggle active
    objSlide.toggleClass('active');

    if (strTarget === "filters") {
        $('.filter-fixed').toggleClass("hidden");
    }
    // overlay = ::after so if you click on the after the slide-left has to be close
    ClickOnAfter();
    //overflow hidden on body = no scrollbar on body - Windows
    $('body').toggleClass('overflow-hidden');
    // Remove Active class from initial buttons
    $('[data-target="' + strTarget + '"].hover-circle.active').removeClass('active');
    // Remove desktop hover state from menu items
    $('.menu-hover.menu-open').removeClass('menu-open');
    // Submenu
    $('.supermenu-sub.active').removeClass('active');
    $('[data-action="toggle-submenu"].text-primary-mint').addClass('text-neutral').removeClass('text-primary-mint');
    $('[data-action="toggle-submenu"].text-primary-mint').find($('[data-icon="angle-right"]')).addClass('text-neutral-300').removeClass('text-primary-mint');
}

function ClickOnAfter() {
    $(document).on('click', function (e) {
        const objClicked = e.target;
        const isSlideLeft = objClicked.classList.contains('slide-left') && objClicked.classList.contains('active');
        const isUnifiedMenu = objClicked.classList.contains('unified-menu') && objClicked.classList.contains('active');
        if (isSlideLeft || isUnifiedMenu) {
            objClicked.classList.remove('active');
            objClicked.classList.remove('overflow-y-scroll');
            $('.supermenu-sub.active').removeClass('active');
            $('body').removeClass('overflow-hidden');
        }
    });
}